import * as React from "react";
import { singleton } from "logic/singleton";
const InputsContext = React.createContext(void 0);
export default singleton("contexts.InputsContext", () => InputsContext);
